/** @jsxImportSource @emotion/react */
import { styleguideColors as COLORS, styleguideFontSize as FONT_SIZE, styleguideFontWeight as FONT_WEIGHT } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { css } from '@emotion/react';
import { styleguideFontFamily as FONT } from '@kaiizen/kai-shiki/core';

/**
 * The tag a line item or task row carries for each modifier applied to it (KAIDEV-4206).
 *
 * The styleguide `.pill`, same as the status badge beside it, in the one neutral tone: the two
 * read as the same kind of object, which is the point — neither is clickable, and a modifier is
 * as much a fact about the row as its status. Sizing comes from the padding rather than a fixed
 * height so the two always match. The label comes from org settings, so a rename reaches every
 * tag without touching this component; uppercase is the pill's own rule, not a choice about the
 * label, and is one of the things the Figma pass should confirm.
 */
const MODIFIER_TAG_STYLE = css`
  label: MODIFIER_TAG;
  display: inline-flex;
  align-items: center;
  font-family: ${FONT.mono};
  font-size: ${pxToRem(FONT_SIZE.monoCaption)};
  font-weight: ${FONT_WEIGHT.bold};
  letter-spacing: 0.07em;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 2px 7px 1px;
  border-radius: 4px;
  background: ${COLORS.midtone};
  color: ${COLORS.paper};
`;

export const ModifierTag = ({ label }: { label: string }) => <span css={MODIFIER_TAG_STYLE} data-testid='modifier-tag'>{label}</span>;
